import { t } from 'i18next';
import { crudStatusEnum } from '../enums';

export const crudStatusEnumLabels: Record<number, string> = {
    [crudStatusEnum.OK]: 'active',
    [crudStatusEnum.DELETED]: 'deleted',
    [crudStatusEnum.INACTIVE]: 'inactive',
};

export const getCrudStatusLabel = (state?: number): string => {
    return state !== undefined && crudStatusEnumLabels[state] ? t(crudStatusEnumLabels[state]) : '';
};
